// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_7l-0";
export var optionCard = "_7l-1";